import styled from "styled-components";
import GreenFilledTick from "src/assets/green_filled_tick.png"

export const MyPlanBackground = styled.div`
    background: #FFF;
    width: 100%;
    height: 100vh;
    font-family: Outfit;
    display: flex;
    flex-direction: column;
    @media (min-width: 980px) {
        display: grid;
        grid-template-columns: 40% 60%;
    }
`

// header 

export const MyPlanHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    position: fixed;
    top: 0;
    background: #FFF;
    box-shadow: 0px 5px 25px 0px #00000040;
    height: 64px;
    padding: 0 20px;
    @media (min-width: 980px) {
        width: 40%;
    }
`

export const MPPBackButtonContainer = styled.div`
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: #FFF;
    flex-shrink: 0;
    border: 1px solid #d3d8de;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    &:hover {
        background: #f2f2f2;
    }
`

export const MPHeaderTitle = styled.div`
    font-size: 18px;
    font-weight: 700;
    color: #000000;
    @media (min-width: 980px) {
        font-size: 20px;
    }
`

// left wala section

export const MyPlanPhasesSection = styled.div`
    margin-top: 64px;
    background: #FFF;
    overflow-x: scroll;
    height: 136px;
    flex-shrink: 0;
    display: flex;
    gap: 31px;
    padding-left: 31px;
    padding-right: 31px;
    padding-top: 20px;
    /* Hide scrollbar for Chrome, Safari and Opera */
    ::-webkit-scrollbar {
        display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    @media (min-width: 980px) {
        padding-right: 0;
        padding-left: 20px;
        padding-top: 62px;
        padding-bottom: 62px;
        flex-direction: column;
        align-items: flex-end;
        gap: 31px;
        height: calc(100% - 64px);
        overflow-x: unset;
        overflow-y: scroll;
    }
`

export const MPPhaseItemContainer = styled.div`
    width: 100%;
    padding: 32px;
    background: ${props => props?.active ? '#224053' : '#E3E3E3'};
    border-radius: 20px 0 0 20px;
    cursor: pointer;
    ${props => !props?.active && 'margin-right: 44px;'};
    ${props => !props?.active && 'width: calc(100% - 44px);'};
    ${props => !props?.active && 'border-radius: 20px;'};
    ${props => props?.active && 'padding: 32px 76px 32px 32px;'};
`

export const MPPhaseItemTitleAndProgress = styled.div`
    display: flex;
    flex-direction: column;
    @media (min-width: 1280px){
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
`

export const MPPhaseItemTitle = styled.div`
    font-size: 22px;
    font-weight: 700;
    color: ${props => props?.active ? '#FFF' : '#5e5e5e'};
`

export const MPPhaseItemInfoText = styled.div`
    font-size: 14px;
    font-weight: 300;
    color: ${props => props?.active ? '#ededed' : '#5e5e5e'};
`

export const MPPhaseItemCompletedText = styled.div`
    font-size: 14px;
    font-weight: 500;
    width: 130px;
    color: ${props => props?.active ? '#F4CE8A' : '#BF7B00'};
    text-align: left;
    @media (min-width: 1280px) {
        margin-left: 15px;
        text-align: center;
    }
`

export const MPPhaseProgressContainer = styled.div`
    border-radius: 15px;
    background: #3E6379;
    height: 8.7px;
    width: 130px;
    flex-shrink: 0;
    overflow: hidden;
    position: relative;
    margin: 15px 0 15px 0;
    @media(min-width: 1280px) {
        margin: 0 0 5px 15px;
    }
`

export const MPPhaseProgressFilled = styled.div`
position: absolute;
background: #44FF33;
top: 0;
left: 0;
height: 100%;
width: ${props => `${props?.progress}%`};
transition: all 0.4s ease-in-out;
`

export const MPPhaseDescription = styled.div`
    display: flex;
    gap: 20px;
    align-items: flex-start;
    font-size: 14px;
    color: ${props => props?.active ? '#DADADA' : '#7A7A7A'};
    margin-top: 20px;
`

export const MPPhaseImage = styled.img`
    width: 60px;
    object-fit: contain;
`

export const MPMobilePhaseItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    min-width: 200px;
    padding: 20px;
    flex-shrink: 0;
    background: ${props => props?.active ? '#224053' : '#E3E3E3'};
    border-radius: 20px 20px 0 0;
    cursor: pointer;
`

export const MPMobilePhaseItemTitle = styled.div`
    font-size: 18px;
    font-weight: 500;
    color: ${props => props?.active ? '#FFF' : '#5e5e5e'};
`

export const MPMobilePhaseDescription = styled.div`
    display: flex;
    gap: 20px;
    align-items: flex-start;
    font-size: 16px;
    color: #DADADA;
    margin: 20px 0;
`

// right wala section

export const MyPlanPhaseDetailSection = styled.div`
    background: #224053;
    height: 100%;
    overflow-y: scroll;
    padding: 15px;
    @media(min-width: 980px) {
        border-radius: 20px 0 0 20px;
        padding: 54px;
    }
`

export const MyPlanPhaseDayItemContainer = styled.div`
    width: 100%;
    gap: 10px;
    display: flex;
`

export const MPPDayProgressConnectorContainer = styled.div`
    // height: 100%;
    height: 200px;
    width: 45px;
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const MPPDayHeadingContainer = styled.div`
    width: 100%;
    flex-shrink: 0;
    display: grid;
    grid-template-columns: 3fr 1fr; 
    align-items: center;
`

export const MPPDayHeading = styled.div`
    font-size: 18px;
    font-weight: 600;
    color: #FFF;
`

export const MPDayHeadingDateAndParticipants = styled.div`
    display: flex;
    align-items: center;
    justify-content: right;
    font-size: 16px;
    font-weight: 400;
    color: #FFF;
`

export const MPDayFlagContainer = styled.div`
    background: #FFF;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const MPDayThread = styled.div`
    width: 5px;
    height: 100%;
    border-right: 2px ${props => props?.completed ? 'solid' : 'dashed'} ${props => props?.completed ? '#24AE5F' : '#7899AC'};
`

export const MPDayCompletionTick = styled.div`
    width: 29px;
    height: 29px;
    flex-shrink: 0;
    border-radius: 50%;
    background: ${props => props?.complete ? `url(${GreenFilledTick})` : '#e6e6e6'};
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
`

export const MPPDayItemEventsContainer = styled.div`
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    gap: 18px;
    @media (min-width: 980px){
        gap: 24px;
        padding: 40px 0;
    }
`

export const MPDayItemEventParent = styled.div`
    width: 100%;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.5fr 1fr 4fr;
    align-items: center;
    cursor: pointer;
    @media (min-width: 980px) {
        width: 80%;
    }
`

export const MPDayItemEventTimeContainer = styled.div`
    height: 85%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #5486A3;
    color: #FFF;
    text-align: center;
    border-radius: 10px 0 0 10px;
    font-size: 14px;
    @media(min-width: 980px) {
        font-size: 16px;
    }
`

export const MPDayItemEventDetailsTitle = styled.div`
    color: #FFF;
    font-weight: 500;
    font-size: 14px;
    @media(min-width: 980px) {
        font-size: 16px;
    }
`

export const MPDayItemEventDetailsSubtitle = styled.div`
    color: #FFF;
    font-weight: 400;
    font-size: 12px;
    @media(min-width: 980px) {
        font-size: 14px;
    }
`

export const MPDayItemEventDetailsContainer = styled.div`
    background: #94c6e3;
    border-radius: 10px;
    position: relative;
    padding: 10px 40px 10px 10px;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media (min-width: 980px) {
        padding: 25px 80px 25px 25px;
    }
    &:hover {
        background: #FFF;
        ${MPDayItemEventDetailsTitle}{
            color: #68A3C5;
        }
        ${MPDayItemEventDetailsSubtitle}{
            color: #68A3C5;
        }
    }
`

export const MPDayItemEventPicture = styled.img`
    object-fit: cover;
    position: absolute;
    border-radius: 5px;
    right: 2.5px;
    width: 35px;
    height: 35px;
    margin: auto;
    @media (min-width: 980px) {
        right: 5px;
        width: 70px;
        height: 70px;
    }
`